__turbopack_context__.v({
  "closeBtn": "ProductSlider1-module__mDl69W__closeBtn",
  "mainImage": "ProductSlider1-module__mDl69W__mainImage",
  "mainImg": "ProductSlider1-module__mDl69W__mainImg",
  "navBtn": "ProductSlider1-module__mDl69W__navBtn",
  "next": "ProductSlider1-module__mDl69W__next",
  "prev": "ProductSlider1-module__mDl69W__prev",
  "scrollFollow": "ProductSlider1-module__mDl69W__scrollFollow",
  "skuOverlay": "ProductSlider1-module__mDl69W__skuOverlay",
  "sliderWrap": "ProductSlider1-module__mDl69W__sliderWrap",
  "stickyLeft": "ProductSlider1-module__mDl69W__stickyLeft",
  "thumbDim": "ProductSlider1-module__mDl69W__thumbDim",
  "thumbSwiper": "ProductSlider1-module__mDl69W__thumbSwiper",
  "thumbnailList": "ProductSlider1-module__mDl69W__thumbnailList",
  "viewerBox": "ProductSlider1-module__mDl69W__viewerBox",
  "viewerImage": "ProductSlider1-module__mDl69W__viewerImage",
  "viewerOverlay": "ProductSlider1-module__mDl69W__viewerOverlay",
  "viewerSlide": "ProductSlider1-module__mDl69W__viewerSlide",
  "viewerSwiper": "ProductSlider1-module__mDl69W__viewerSwiper",
});
